export const uk = {
    additions: 'Дополнения: {additionsList}',
    'banner-has-template': 'используется шаблон',
    id: '№ {id}',
    info: '{bannerId} — {bannerHasTemplate}'
};
